import React, { useMemo, useState } from "react";

const DAY_LABELS = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];

function formatShortDate(dateString) {
  if (!dateString) return "";
  const parts = dateString.split("-");
  return `${parts[2]}.${parts[1]}`;
}

const ScheduleChkTemplateAssignPanel = ({
  templates = [],
  shifts = [],
  weekDates = [],
  selectedTemplateId,
  onSelect,
  filledCount = 0,
  slotCount = 0,
  disabled = false,
  message,
  onCollapse,
}) => {
  const [query, setQuery] = useState("");
  const [onlyEmpty, setOnlyEmpty] = useState(true);

  const occupancy = useMemo(() => {
    const map = new Map();
    (shifts || []).forEach((shift) => {
      if (shift?.template_shift_id != null) {
        map.set(Number(shift.template_shift_id), shift);
      }
    });
    return map;
  }, [shifts]);

  const grouped = useMemo(() => {
    const needle = query.trim().toLowerCase();
    const inWeek = (templates || []).filter((ts) =>
      weekDates.includes(ts.date),
    );

    const days = weekDates.map((date, index) => {
      const items = inWeek
        .filter((ts) => ts.date === date)
        .map((ts) => ({
          template: ts,
          shift: occupancy.get(Number(ts.id)) || null,
        }))
        .filter((item) => {
          if (onlyEmpty && item.shift) return false;
          if (!needle) return true;
          const ts = item.template;
          const person = item.shift
            ? `${item.shift.user_surname ?? ""} ${item.shift.user_name ?? ""}`
            : "";
          const hay =
            `${ts.station_name ?? ""} ${ts.group_station_name ?? ""} ${ts.start}-${ts.end} ${person}`.toLowerCase();
          return hay.includes(needle);
        })
        .sort((a, b) => {
          if (!!a.shift !== !!b.shift) return a.shift ? 1 : -1;
          return Number(a.template.start) - Number(b.template.start);
        });

      return {
        date,
        label: DAY_LABELS[index] || "",
        items,
      };
    });

    return days.filter((day) => day.items.length > 0);
  }, [templates, weekDates, occupancy, onlyEmpty, query]);

  const selected = (templates || []).find(
    (ts) => Number(ts.id) === Number(selectedTemplateId),
  );
  const selectedShift = selected
    ? occupancy.get(Number(selected.id)) || null
    : null;

  return (
    <aside className="schedule-chk-assign-panel">
      <div className="schedule-chk-assign-panel-head">
        <div className="schedule-chk-assign-panel-title-row">
          <h4>Шаблоны</h4>
          {onCollapse && (
            <button
              type="button"
              className="schedule-chk-week-tool-btn"
              onClick={onCollapse}
            >
              Скрыть
            </button>
          )}
        </div>
        <p>
          {slotCount > 0
            ? `Занято ${filledCount} из ${slotCount} слотов`
            : "Выберите шаблон, затем кликните по сотруднику"}
        </p>
      </div>

      {disabled && (
        <div className="schedule-chk-assign-note">
          После согласования ТУ изменения только через служебную записку —
          клик откроет окно.
        </div>
      )}

      {selected ? (
        <div className="schedule-chk-assign-selected">
          Ставите:{" "}
          <b>
            {selected.station_name} {selected.start}–{selected.end}
          </b>
          <span>
            {formatShortDate(selected.date)}
            {selectedShift
              ? ` · ${selectedShift.user_surname} ${selectedShift.user_name}`
              : " · свободно"}
          </span>
          <button type="button" onClick={() => onSelect(null)}>
            Сбросить
          </button>
        </div>
      ) : (
        <div className="schedule-chk-assign-selected is-empty">
          Шаблон не выбран — клик по смене откроет обычное окно
        </div>
      )}

      <input
        type="search"
        className="form-control form-control-sm"
        placeholder="Поиск: станция, время, ФИО"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />

      <label className="schedule-chk-assign-toggle">
        <input
          type="checkbox"
          checked={onlyEmpty}
          onChange={(e) => setOnlyEmpty(e.target.checked)}
        />
        Только свободные
      </label>

      {message && (
        <div
          className={`schedule-chk-assign-message ${
            message.type === "error" ? "is-error" : "is-ok"
          }`}
        >
          {message.text}
        </div>
      )}

      <div className="schedule-chk-assign-list">
        {grouped.map((day) => (
          <section key={day.date} className="schedule-chk-tpl-day">
            <h5>
              {day.label} <span>{formatShortDate(day.date)}</span>
            </h5>
            <ul>
              {day.items.map(({ template: ts, shift }) => {
                const active = Number(selectedTemplateId) === Number(ts.id);
                return (
                  <li key={ts.id}>
                    <button
                      type="button"
                      className={`schedule-chk-assign-person ${
                        active ? "is-active" : ""
                      } ${shift ? "is-filled" : "is-empty-slot"}`}
                      onClick={() => onSelect(active ? null : ts.id)}
                    >
                      <span className="schedule-chk-assign-person-name">
                        {ts.station_name}
                        <span className="schedule-chk-assign-time">
                          {ts.start}–{ts.end}
                        </span>
                      </span>
                      <span className="schedule-chk-assign-person-meta">
                        {ts.group_station_name}
                        <strong>
                          {shift
                            ? `${shift.user_surname} ${shift.user_name}`.trim()
                            : "свободно"}
                        </strong>
                      </span>
                    </button>
                  </li>
                );
              })}
            </ul>
          </section>
        ))}
        {grouped.length === 0 && (
          <div className="schedule-chk-assign-empty">
            {onlyEmpty ? "Свободных шаблонов нет" : "Ничего не найдено"}
          </div>
        )}
      </div>
    </aside>
  );
};

export default ScheduleChkTemplateAssignPanel;
